<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-button-go-up></app-button-go-up>
<app-footer></app-footer>
